/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFVirustotalData } from './CRSFVirustotalData';
import {
    CRSFVirustotalDataFromJSON,
    CRSFVirustotalDataFromJSONTyped,
    CRSFVirustotalDataToJSON,
} from './CRSFVirustotalData';
import type { CRSFVirustotalDataEmpty } from './CRSFVirustotalDataEmpty';
import {
    CRSFVirustotalDataEmptyFromJSON,
    CRSFVirustotalDataEmptyFromJSONTyped,
    CRSFVirustotalDataEmptyToJSON,
} from './CRSFVirustotalDataEmpty';

/**
 * 
 * @export
 * @interface Virustotal
 */
export interface Virustotal {
    /**
     * 
     * @type {string}
     * @memberof Virustotal
     */
    asset: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof Virustotal
     */
    detected_urls?: Array<any>;
    /**
     * 
     * @type {number}
     * @memberof Virustotal
     */
    first_seen?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Virustotal
     */
    hits?: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof Virustotal
     */
    last_seen?: number;
    /**
     * 
     * @type {number}
     * @memberof Virustotal
     */
    total_events: number;
}

/**
 * Check if a given object implements the Virustotal interface.
 */
export function instanceOfVirustotal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "total_events" in value;

    return isInstance;
}

export function VirustotalFromJSON(json: any): Virustotal {
    return VirustotalFromJSONTyped(json, false);
}

export function VirustotalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Virustotal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'detected_urls': !exists(json, 'detected_urls') ? undefined : json['detected_urls'],
        'first_seen': !exists(json, 'first_seen') ? undefined : json['first_seen'],
        'hits': !exists(json, 'hits') ? undefined : json['hits'],
        'last_seen': !exists(json, 'last_seen') ? undefined : json['last_seen'],
        'total_events': json['total_events'],
    };
}

export function VirustotalToJSON(value?: Virustotal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'detected_urls': value.detected_urls,
        'first_seen': value.first_seen,
        'hits': value.hits,
        'last_seen': value.last_seen,
        'total_events': value.total_events,
    };
}

